<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-row>
      <v-spacer></v-spacer>
      <!--      <v-col cols="3" v-if="canUpdateMillingChargeOnSettlement">-->
    </v-row>
    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Society Charges Pending Approval
                </span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
              <v-spacer> </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search"> </v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="btn"
                  v-if="
                    canCreateBrokerCharge &&
                    item['status']['statusName'] ==
                      'PENDING_CHECKER_APPROVAL' &&
                    canEditBrokerCharge(item)
                  "
                  @click="editBrokerCharge(item)"
                  color="primary"
                >
                  Edit
                </v-btn>

                <v-menu
                  offset-y
                  v-if="
                    (canApproveBrokerCharge &&
                      item['status']['statusName'] ==
                        'PENDING_CHECKER_APPROVAL' &&
                      (organisationType.toUpperCase() === 'MARKETER' ||
                        organisationType.toUpperCase() === 'FARMER_SOCIETY')) ||
                    (item['status']['statusName'] == 'PENDING_NCE_APPROVAL' &&
                      organisationType.toUpperCase() === 'GOVERMENT') ||
                    (item['status']['statusName'] == 'PENDING_COOP_APPROVAL' &&
                      organisationType.toUpperCase() === 'COOP BANK')
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      style="color: red"
                      class="actions"
                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="approveRejectChargeShowDialog(item, 1)"
                      >
                        Approve
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="approveRejectChargeShowDialog(item, 0)"
                      >
                        Reject
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:item.contractStartDate="{ item }">
                {{ item.contractStartDate | prettyDate }}
              </template>
              <template v-slot:item.contractEndDate="{ item }">
                {{ item.contractEndDate | prettyDate }}
              </template>
              <template v-slot:item.documentUpload.fileName="{ item }">
                <a
                  href="#"
                  class="primary--text"
                  @click.prevent="downloadContractPDF(item)"
                >
                  {{ item.documentUpload.fileName }}
                </a>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="createBrokerChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Create Broker Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        v-model="grower"
                        :items="filteredGrowers"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Grower"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error grower-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        label="Broker"
                        item-text="name"
                        item-value="value"
                        v-model="broker"
                        :items="filteredBrokers"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Broker"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error grower-error"
                        for="contract"
                      ></label>
                    </v-flex>

                    <!-- <v-flex xs6>
                        <v-text-field label="Charge Rate %" min="1" type="number" v-model="bagRate"></v-text-field>
                        <label class="custom-form-error handling-charge-error" for="contract"></label>
                      </v-flex> -->
                    <v-flex xs6>
                      <v-text-field
                        label="Charge Rate %"
                        min="1"
                        type="number"
                        v-model="handling_charge"
                        :error-messages="chargeErrorMessages"
                        @input="validateCharge"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <label for="contractstartdate">Contract Start Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_start_date"
                        @input="validateEndDate"
                      />
                      <p
                        class="custom-form-error contract-start-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex xs6>
                      <label for="contractenddate">Contract End Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_end_date"
                        :min="contract_start_date"
                      />
                      <p
                        class="custom-form-error contract-end-date-error"
                        for="contract"
                      ></p>
                    </v-flex>

                    <v-flex id="fileupload" xs4>
                      <label for="contract">Contract </label>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        required
                      />
                      <p
                        class="custom-form-error contract-file-error"
                        for="contract"
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="createBrokerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="createBrokerCharge"
                >Submit</v-btn
              >
              <v-progress-circular
                v-show="createBrokerLoader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="editBrokerChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Update Broker Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-text-field
                        v-model="this.actualGrower"
                        label="Grower"
                        readonly
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <!-- <v-text-field v-model="this.charge_rate" label="Charge Rate" readonly></v-text-field> -->
                      <v-text-field
                        label="Charge Rate %"
                        min="1"
                        type="number"
                        v-model="charge_rate"
                      ></v-text-field>
                      <label
                        class="custom-form-error handling-charge-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs6>
                      <label for="contractstartdate">Contract Start Date</label>
                      <datepicker
                        v-model="contract_start_date"
                        id="contractstartdate"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs6>
                      <label for="contractenddate">Contract End Date</label>
                      <datepicker
                        v-model="contract_end_date"
                        :disabled-dates="disabledDates"
                        validate
                        id="contractenddate"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="editBrokerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="updateMillerCharge"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog
        v-model="approveRejectBrokerChargeDialog"
        persistent
        max-width="500"
      >
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Society Charge</v-card-title
            >
            <v-card-text v-if="approveStatus === 1"
              >Do you want to approve the charge?
            </v-card-text>
            <v-card-text v-if="approveStatus === 0"
              >Do you want to reject the charge?
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="approveRejectBrokerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="approveStatus === 1"
                color="secondary"
                @click="approveMillerCharge"
                >Approve</v-btn
              >
              <v-btn
                v-if="approveStatus === 0"
                color="secondary"
                @click="approveMillerCharge"
                >Reject</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import config from "../../../config";
import store from "../../../store";
import http from "../../../http";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  name: "catalogueupload",
  data: function () {
    return {
      gradeDisabled: true,
      defaultGrower: {
        name: "Grower1",
        value: "Grower1",
      },
      defaultWarehouse: {
        name: "Warehouse1",
        value: "Warehouse1",
      },
      defaultSelectedGrade: {
        name: "None",
        value: "None",
      },
      borrowerType: [
        {
          name: "FCS",
          value: "FCS",
        },
        {
          name: "FCS FARMER",
          value: "FCS_FARMER",
        },
        {
          name: "ESTATE FARMER",
          value: "ESTATE_FARMER",
        },
      ],
      coffeeType: [
        {
          name: "CHERRY",
          value: "CHERRY",
        },
        {
          name: "PARCHMENT",
          value: "PARCHMENT",
        },
        {
          name: "CLEAN COFFEE",
          value: "CLEAN COFFEE",
        },
      ],
      gradeType: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeEdit: [],
      gradeTypeCherry: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeParchment: [
        {
          name: "P1",
          value: "P1",
        },
        {
          name: "P2",
          value: "P2",
        },
        {
          name: "P3",
          value: "P3",
        },
      ],
      gradeTypeCleanCoffee: [
        {
          name: "AA",
          value: "AA",
        },
        {
          name: "BB",
          value: "BB",
        },
        {
          name: "C",
          value: "C",
        },
      ],
      rates: [],
      editFarmerType: {},
      editCoffeeType: {},
      editGrade: {},
      editStatus: "",
      cherryRateTemp: { rate: 0, name: "hello" },
      brokerObject: {},
      headers: [
        { text: "Grower", value: "grower.organisationName" },
        { text: "GrowerCode", value: "grower.organisationCode" },
        { text: "Budget", value: "budget" },
        { text: "Start Date", value: "contractStartDate" },
        { text: "End Date", value: "contractEndDate" },
        { text: "Contract", value: "documentUpload.fileName" },
        { text: "Status", value: "status.description" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      borrower_type: "",
      coffee_type: "",
      grade: "",
      rate_amount: "",
      rate_amount_edit: "",
      broker_id: "",
      approveStatus: 0,
      approveRejectDialogTitle: "Do you want to approve the charge?",
      approveRejectDialogButton: "Approve",
      valid: true,
      message: "",
      snackbar: false,
      snackbarColor: "",
      file: "",
      files: [],
      pagination: { sortBy: "id", descending: true },
      search: "",
      searchInput: "",
      permissions: [],
      previewLoading: false,
      approveloading: false,
      declineloading: false,
      createBrokerLoader: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      page: 1,
      confirmDialog: false,
      confirmFile: {},
      confirmMessage: "",
      action: "",
      rateLimitDialog: false,
      createBrokerChargeDialog: false,
      editBrokerChargeDialog: false,
      approveRejectBrokerChargeDialog: false,
      userID: 0,
      username: "",
      grower: "",
      broker: "",
      warehouse: "",
      warehouses: [],
      growers: [],
      brokers: [],
      charge_rate: "",
      start_date: "",
      end_date: "",
      actualGrower: [],
      actualGrowerCode: "",
      handling_charge: "",
      broker_charge: "",
      export_bag_charge: "",
      estate_cured_charge: "",
      contract_start_date: null,
      contract_end_date: null,
      organisationType: "",
      organisationId: 0,
      chargeErrorMessages: [],
    };
  },
  mounted() {
    this.getBrokerCharges();
    this.getWarehouse();
    this.getFCS();
    this.getBrokers();
    this.permissions = store.state.user.roleId.permissions;
  },
  watch: {
    files() {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        1,
        this.numberOfItemsPerPage
      );
      this.numberOfLinks = Math.ceil(
        this.files.length / this.numberOfItemsPerPage
      );
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        val,
        this.numberOfItemsPerPage
      );
    },
  },
  computed: {
    ...mapState({ user: (state) => state.user }),
    canUploadFarmers: function () {
      return this.hasPerm("CAN_UPLOAD_FARMERS");
    },
    canCreateBrokerCharge: function () {
      return this.hasPerm("CAN_CREATE_BROKER_CHARGE");
    },

    canApproveBrokerCharge: function () {
      return this.hasPerm("CAN_APPROVE_BROKER_CHARGE");
    },
    canApproveCatalogue: function () {
      return this.hasPerm("CAN_APPROVE_CATALOGUE");
    },
    filteredList: function () {
      if (this.search === "") {
        return this.paginatedFiles;
      } else {
        return this.files.filter((file) => {
          return file.fileName
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
    },
    userId: function () {
      if (this.user) {
        console.log("user - ", this.user);
        console.log("user2 - ", this.user.organisation.organisationType);
        console.log("username - ", this.user.username);
        this.organisationType = this.user.organisation.organisationType.name;
        this.organisationId = this.user.organisation.id;
        this.userID = this.user.id;
        this.username = this.user.username;
        return this.user.id;
      }
      return 0;
    },
    disabledDates() {
      return {
        to: new Date(this.contract_start_date),
      };
    },
    filteredGrowers() {
      return this.growers.filter((grower) =>
        grower.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
    filteredBrokers() {
      return this.brokers.filter((broker) =>
        broker.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
  },
  methods: {
    // validateCharge () {
    // 	const chargeValue = parseInt(this.handling_charge)

    // 	if (isNaN(chargeValue) || chargeValue <= 0.00 || chargeValue > 100.00) {
    // 		this.chargeErrorMessages = [
    // 			'Charge rate must be a number greater than 0 and cannot be more than 100.'
    // 		]
    // 	} else {
    // 		this.chargeErrorMessages = []
    // 	}
    // },
    downloadContractPDF(file) {
      // Base64 encoded string of a small PDF file
      const base64String = file.documentUpload.file;

      // This function converts a base64 string to a Blob
      function base64ToBlob(base64, type) {
        const binary = atob(base64.replace(/\s/g, ""));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }
        return new Blob([view], { type: type });
      }

      const blob = base64ToBlob(base64String, "application/pdf");
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.setAttribute(
        "download",
        file.documentUpload.fileName + ".pdf"
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    },
    canEditBrokerCharge(item) {
      console.log("Username>>", this.user.username);
      return item.createdBy == this.user.username;
    },
    validateCharge() {
      let chargeValue = parseFloat(this.handling_charge); // Parse as float to handle decimal numbers

      // Round off to two decimal places using toFixed
      chargeValue = parseFloat(chargeValue.toFixed(2));

      if (isNaN(chargeValue) || chargeValue <= 0.0 || chargeValue > 100.0) {
        this.chargeErrorMessages = [
          "Charge rate must be a number greater than 0.00 and cannot be more than 100.00",
        ];
      } else {
        this.handling_charge = chargeValue.toString(); // Update handling_charge with rounded value
        this.chargeErrorMessages = [];
      }
    },
    validateForm() {
      // Add validation logic for other form fields
      if (this.handling_charge === "" || this.chargeErrorMessages.length > 0) {
        // Display an error or take appropriate action
        console.error(
          "Form submission prevented. Please fill in all fields correctly."
        );
        return false;
      }
      // Perform additional form validation if needed
      return true;
    },

    validateEndDate() {
      // Validate end date against start date
      if (
        this.contract_end_date &&
        this.contract_start_date > this.contract_end_date
      ) {
        this.contract_end_date = this.contract_start_date;
      }
    },
    getWarehouse: function () {
      const url = config.serverURI + "/organization/getWarehouse";
      axios
        .post(url)
        .then((response) => {
          this.warehouses = response.data;
          console.log("warehouse --- ", this.warehouses);
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    getFCS() {
      if (this.user.organisation.organisationType.name === "FARMER_SOCIETY") {
        // Use data from user.organisation
        this.growers.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      } else {
        const url = config.serverURI + "/organization/get-fcs";
        axios
          .get(url)
          .then((response) => {
            console.log("FCS>>>>", response.data);
            // this.growers = response.data
            response.data.forEach((x) => {
              this.growers.push({
                name:
                  x.organisationName + " " + " -" + " " + x.organisationCode,
                value: x.organisationCode,
              });
            });
          })
          .catch((error) => {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: error.response.message,
            });
          });
      }
    },
    getBrokers() {
      if (this.user.organisation.organisationType.name === "MARKETER") {
        // Use data from user.organisation
        this.brokers.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      } else {
        // Fetch data from API
        const url = config.serverURI + "/organization/get-marketers";
        axios
          .get(url)
          .then((response) => {
            console.log("BROKERS>>>>", response.data);
            response.data.forEach((x) => {
              this.brokers.push({
                name: x.organisationName + " - " + x.organisationCode,
                value: x.organisationCode,
              });
            });
          })
          .catch((error) => {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: error.response.message,
            });
          });
      }
    },
    canBeApproved(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    canBeDeclined(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    paginationMethod(items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1;
      const from = pageNumber * limitPerPage;
      let to = (pageNumber + 1) * limitPerPage;
      if (to >= items.length) {
        to = items.length;
      }
      return items.slice(from, to);
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    openCreateDialog() {
      this.createBrokerChargeDialog = true;
    },

    createBrokerCharge() {
      const grower = this.grower;
      const broker = this.broker;
      console.log("broker", broker);
      //   const warehouse = this.warehouse
      var roundedchargeValue = parseFloat(this.handling_charge).toFixed(2);
      console.log("Rounded charge value", roundedchargeValue);
      const handlingCharge = roundedchargeValue;
      const contractStartDate = this.contract_start_date;
      const contractEndDate = this.contract_end_date;

      console.log(grower, handlingCharge, contractStartDate, contractEndDate);

      $(".custom-form-error").css("display", "none");

      if (grower === "") {
        $(".grower-error").css("display", "inline");
        $(".grower-error").text("Please select grower");
        return;
      }

      if (handlingCharge === "") {
        this.chargeErrorMessages = ["Please enter handling charge."];
        return; // Stop further execution of the method
      }

      if (contractStartDate == null) {
        $(".contract-start-date-error").css("display", "block");
        $(".contract-start-date-error").text(
          "Please select contract start date"
        );
        return;
      }

      if (contractEndDate == null) {
        $(".contract-end-date-error").css("display", "block");
        $(".contract-end-date-error").text("Please select contract end date");
        return;
      }

      if (this.file.length === 0) {
        $(".contract-file-error").css("display", "block");
        $(".contract-file-error").text("Please upload file");
        return;
      }
      this.createBrokerLoader = true;

      //   this.showProgressBar = true
      const urlUpload = config.serverURI + "/society/upload";

      const formData = new FormData();
      formData.append("file", this.file);

      axios({ url: urlUpload, method: "POST", data: formData })
        .then((response) => {
          if (response.data.error !== false) {
            this.createBrokerLoader = false;
            $(".contract-file-error").css("display", "block");
            $(".contract-file-error").text(
              "Something went wrong, please try again"
            );
            return;
          }
          const fileId = response.data.message;
          console.log("fileId ## ", fileId);
          var url =
            config.serverURI +
            "/society/create?userId=" +
            this.userID +
            "&fileId=" +
            fileId +
            "&grower=" +
            grower.value +
            "&handlingCharge=" +
            handlingCharge +
            "&contractStartDate=" +
            contractStartDate +
            "&contractEndDate=" +
            contractEndDate +
            "&broker=" +
            broker.value;

          axios
            .post(url, {})
            .then((response) => {
              var data = response.data;
              var checkError = data.error;
              this.createBrokerChargeDialog = false;
              console.log("checkError ", checkError);
              this.createBrokerLoader = false;

              //   this.approveloading = false
              if (checkError !== undefined) {
                this.handling_charge = "";
                this.broker_charge = "";
                this.export_bag_charge = "";
                this.estate_cured_charge = "";
                this.contract_start_date = "";
                this.contract_end_date = "";
                this.broker = "";
                this.grower = "";

                this.message = data.message;
                this.snackbar = true;
                this.snackbarColor = "error";
                return;
              }

              this.handling_charge = "";
              this.broker_charge = "";
              this.export_bag_charge = "";
              this.estate_cured_charge = "";
              this.contract_start_date = "";
              this.contract_end_date = "";
              this.broker = "";
              this.grower = "";

              this.message = "Successfully added society charge";
              this.snackbar = true;
              this.snackbarColor = "primary";
              this.getBrokerCharges();
            })
            .catch((error) => {
              this.createBrokerLoader = false;
              this.message = "Something went wrong, please try again";
              this.snackbar = true;
              this.snackbarColor = "error";
            });
        })
        .catch((error) => {
          $(".contract-file-error").css("display", "block");
          $(".contract-file-error").text(error.response.data.message);
        })
        .finally(() => {
          this.showProgressBar = false;
        });
    },
    approveRejectChargeShowDialog(item, status) {
      console.log(item);
      console.log(status);
      this.approveStatus = status;
      this.broker_id = item.id;
      this.approveRejectBrokerChargeDialog = true;
    },
    editBrokerCharge(item) {
      console.log("ITM -> ", item);
      $(".custom-form-error").css("display", "none");
      this.editBrokerChargeDialog = true;
      this.brokerObject = item;
      this.actualGrower = item.grower.organisationName;
      this.actualGrowerCode = item.grower.organisationCode;
      this.charge_rate = item.chargeRate;
      this.contract_start_date = this.formatDate(item.contractStartDate);
      this.contract_end_date = this.formatDate(item.contractEndDate);
      this.editStatus = item.status.statusName;
      // this.rate_amount_edit = item.rate
      this.broker_id = item.id;
    },
    formatDate(providedDate) {
      const date = new Date(providedDate);
      const day = ("0" + date.getUTCDate()).slice(-2);
      const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Adding 1 because month is zero-based
      const year = date.getUTCFullYear();
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    getBrokerCharges() {
      console.log("orgTYPE ", this.username.toUpperCase());
      // let url = '/broker/findAllOrderByOrganisationId?organisationId=' + this.organisationId
      let url = "/society/getAllForApproval";

      // if (this.organisationType.toUpperCase() !== 'MARKETER') {
      // 	url = '/broker/findAll'
      // }
      http
        .get(config.serverURI + url)
        .then((response) => {
          this.rates = response.data;
          console.log("RR -> ", response.data);
        })
        .catch((error) => {
          console.log("error", error);
          this.$store.dispatch(
            "alert/displayAlert",
            {
              snackbar: true,
              color: "error",
              message: error.response
                ? error.response.data.message
                : "Error ocurred",
            },
            { root: true }
          );
        });
    },

    updateMillerCharge() {
      const grower = this.actualGrower;
      const growerCode = this.actualGrowerCode;
      // const warehouse = this.warehouse
      const chargeRate = this.charge_rate;
      const startDate = this.contract_start_date;
      const endDate = this.contract_end_date;

      console.log(
        "Text>>>",
        grower,
        growerCode,
        chargeRate,
        startDate,
        endDate
      );

      $(".custom-form-error").css("display", "none");

      if (grower === "") {
        $(".grower-edit-error").css("display", "inline");
        $(".grower-edit-error").text("Please select grower");
        return;
      }

      // if (warehouse === '') {
      //   $('.warehouse-edit-error').css('display', 'inline')
      //   $('.warehouse-edit-error').text('Please select warehouse')
      //   return
      // }

      if (chargeRate === "") {
        $(".handling-charge-edit-error").css("display", "inline");
        $(".handling-charge-edit-error").text("Please enter handling charge");
        return;
      }

      $(".custom-form-error").css("display", "none");

      if (grower !== "" || chargeRate !== "") {
        var url = config.serverURI + "/society/update";
        axios
          .put(url, {
            userID: this.userID,
            brokerId: this.broker_id,
            grower: grower,
            handlingCharge: chargeRate,
            contractStartDate: startDate,
            contractEndDate: endDate,
          })
          .then((response) => {
            var data = response.data;
            var checkError = data.error;
            this.editBrokerChargeDialog = false;
            console.log("checkErroApprover ", checkError);

            this.approveloading = false;
            if (checkError !== undefined) {
              this.message = data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              return;
            }

            this.handling_charge = "";
            this.broker_charge = "";
            this.export_bag_charge = "";
            this.estate_cured_charge = "";
            this.contract_start_date = "";
            this.contract_end_date = "";

            this.message = "Successfully updated Society charge";
            this.snackbar = true;
            this.snackbarColor = "primary";
            this.getBrokerCharges();
          })
          .catch((error) => {
            this.approveloading = false;
            this.rateLimitDialog = false;
            this.message = "Something went wrong, please try again";
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      } else {
        this.message = "Please enter all fields";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
    approveMillerCharge() {
      const brokerId = this.broker_id;
      if (brokerId !== "") {
        var url =
          config.serverURI +
          "/society/approve?userId=" +
          this.userID +
          "&brokerId=" +
          brokerId +
          "&status=" +
          this.approveStatus +
          "&organisationType=" +
          this.organisationType;
        axios
          .put(url, {})
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then((response) => {
            var data = response.data;
            var checkError = data.error;
            this.approveRejectBrokerChargeDialog = false;
            console.log("checkError ", checkError);
            if (checkError !== undefined) {
              this.message = data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              return;
            }
            // this.message = "Successfully approved society charge";
            let msg = "Successfully approved society charge";
            if (this.approveStatus === 0) {
              msg = "Successfully rejected society charge";
            }
            this.snackbar = true;
            this.snackbarColor = "primary";
            this.getBrokerCharges();
          })
          .catch((error) => {
            this.approveRejectBrokerChargeDialog = false;
            this.message = "Something went wrong, please try again";
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      } else {
        this.message = "Please enter all checkoffSettlementDetails";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
  },
};
</script>
<style>
.custom-form-error {
  display: none;
  color: red;
}
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn {
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513b !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733d29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733d29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #f2d0a7;
  color: #733d29;
}
.pagination > li.active > .page-link {
  background: #00513b;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col {
  border: 1px solid brown;
}
</style>
